import { render } from "./ReceiveMoney.vue?vue&type=template&id=c9970c28"
import script from "./ReceiveMoney.vue?vue&type=script&lang=js"
export * from "./ReceiveMoney.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__